import {Validator} from 'vee-validate';


const zippy = (value)=>{
  let isWest = 10000 <= value && value <= 86900;
  let isEast = 87000 <= value && value <= 98859;
  return (isEast || isWest);
}

Validator.extend('zippy', {
  getMessage: 'Postal Code Invalid',
  validate: zippy
});





export default zippy;
